export function isRoyalMail(code: string | null | undefined): boolean {
  if (!code) return false;
  return ["ROYALMAIL", "RM", "PARCELFORCE", "PARCELFORCEWORLDWIDE"].includes(
    String(code).toUpperCase().replace(/[^A-Z]/g, ""),
  );
}

export function getReconciliationStatus(result: any): "complete" | "warning" | "unknown" {
  if (!result || !result.status) return "unknown";
  return result.status === "warning" ? "warning" : "complete";
}
